module.exports = __webpack_public_path__ + "img/preloader.ec074f4c.svg";